module.exports = __webpack_public_path__ + "img/ico_sync.9c73425e.png";